import { authBridge } from '../lib/AuthBridge.js'
import { useAuthStore } from '../stores/authStore.js'
import { clearLocalTokens } from '../features/auth/lib/authSession.js'

export function useLogout() {
  const clearUser = useAuthStore((s) => s.clearUser)

  // The ONLY path allowed to hit Kinde /logout — it revokes the SSO session
  // and refresh token, ending every tab (and the legacy app). Automatic
  // failure paths must use teardownLocalSession() instead.
  return async () => {
    clearUser()
    clearLocalTokens()
    await authBridge.logout()
  }
}
